import { diningActions } from '../actions';

const initialState = {
  loading: true,
  query: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case diningActions.LOADING_START:
      return {
        ...state,
        loading: true
      };

    case diningActions.LOADING_END:
      return {
        ...state,
        loading: false
      };

    case diningActions.SET_SEARCH_VALUE:
      const query = action.payload;

      return {
        ...state,
        query
      };

    default:
      return state;
  }
};
